import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import Paginator from '@/components/v2/Paginator.vue';
import ProductManager from '@/components/v2/ecommerce/ProductManager.vue';
import CardItem from '@/components/v2/CardItem.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import CopierDialog from '@/components/v2/CopierDialog.vue';
import CopierMixin from '@/helpers/vue_mixins/v2/CopierMixin';
import { ECOMMERCE_PAGINATION_OPTIONS } from '@/helpers/constants/app';
import ProductReferralMixin from '@/helpers/vue_mixins/v2/ecommerce/ProductReferralMixin';
let ProductGridView = class ProductGridView extends Mixins(ViewportSizeMixin, AlertMixin, CopierMixin, ProductReferralMixin) {
    constructor() {
        super(...arguments);
        this.paginationLimit = 10;
    }
    paginationOptions(totalCount) {
        const index = ECOMMERCE_PAGINATION_OPTIONS.findIndex((v) => v >= totalCount) + 1;
        return index === 0
            ? ECOMMERCE_PAGINATION_OPTIONS
            : ECOMMERCE_PAGINATION_OPTIONS.slice(0, index);
    }
    displayPaginator(total) {
        return total > this.paginationLimit;
    }
    get pageTitle() {
        return this.$route.meta.title;
    }
};
__decorate([
    Prop({ type: String, default: null })
], ProductGridView.prototype, "categoryUuid", void 0);
__decorate([
    Prop({ type: String, default: null })
], ProductGridView.prototype, "keyword", void 0);
ProductGridView = __decorate([
    Component({
        components: {
            ProductManager,
            CardItem,
            Draggable,
            CopierDialog,
            Paginator,
        },
    })
], ProductGridView);
export default ProductGridView;
